@use '../../theme/variables.scss';
@use "../../theme/animations";
@use "../../theme/colors";
@use "../../theme/positioning";
@use "../../theme/spacing";
@use "../../theme/typography";

typography.$default-btn-line-height: 20px;

.button {
  cursor: pointer;
  user-select: none;
  outline: none;
  border: none;
  white-space: nowrap;
  text-decoration: none;
  line-height: typography.$default-btn-line-height;
  text-align: center;
  margin: spacing.$default-btn-margin;
  -webkit-tap-highlight-color: transparent;
  border-radius: positioning.$default-btn-radius;
  padding: spacing.$default-btn-padding;
  transition: animations.$default-transition;
  font-family: var(--font-family-base), typography.$font-fallback;
  font-size: typography.$default-btn-font-size;
  font-weight: typography.$default-btn-font-weight;
  min-width: auto;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  // Prevent select
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /**
  *   Button Types
  */

  &.button--cta {
    background-color: var(--color-fill-cta);
    color: var(--color-text-primary);
    &:not(.button--disabled):hover {
      background-color: var(--color-fill-cta-hover);
    }

    &.button--fab {
      border-color:  var(--color-fill-cta);
      &:hover {
        background-color: var(--color-bg-primary) !important;
        border-color:  var(--color-fill-cta);
      }
    }
  }

  &.button--primary {
    background-color: var(--color-fill-primary);
    color: var(--color-text-on-brand);
    &:not(.button--disabled):hover {
      background-color: var(--color-fill-primary-hover);
    }

    &.button--fab {
      border-color: var(--color-border-brand);
      background-color: var(--color-bg-invert);
      &:hover {
        color: var(--color-text-brand);
        background-color: var(--color-bg-primary) !important;
        border-color: var(--color-border-brand);
      }
    }
  }

  &.button--secondary {
    background-color: var(--color-fill-secondary);
    color: var(--color-text-primary);
    &:not(.button--disabled):hover {
      background-color: var(--color-fill-secondary-hover);
    }

    &.button--fab {
      border-color: var(--color-border-tertiary);
      &:hover {
        color: var(--color-text-secondary);
        background-color: var(--color-bg-primary) !important;
        border-color: var(--color-border-tertiary);
      }
    }
  }

  &.button--tertiary {
    background-color: var(--color-fill-tertiary);
    color: var(--color-text-primary);
    &:not(.button--disabled):hover {
      background-color: var(--color-fill-tertiary-hover);
    }

    &.button--fab {
      border-color: var(--color-fill-tertiary);
      &:hover {
        color: var(--color-fill-tertiary);
        background-color: var(--color-bg-primary) !important;
        border-color: var(--color-fill-tertiary);
      }
    }
  }

  &.button--grey {
    background-color: var(--color-fill-secondary);
    color: var(--color-text-primary);
    &:not(.button--disabled):hover {
      background-color: var(--color-fill-secondary-hover);
    }

    &.button--fab {
      border-color: var(--color-border-primary);
      &:hover {
        color: var(--color-text-primary);
        background-color: var(--color-bg-primary) !important;
        border-color: var(--color-border-primary);
      }
    }
  }

  &.button--light-grey {
    background-color: var(--color-bg-secondary);
    color: colors.$gray500;
    &:not(.button--disabled):hover {
      background-color: var(--color-bg-secondary-hover);
      color: var(--color-text-primary);
    }

    &.button--fab {
      border: 0px;
      &:hover {
        // background-color: $white!important;
        // border-color: $gray50;
      }
    }
  }

  &.button--clear {
    background: none;
    color: colors.$gray500;
    &:not(.button--disabled):hover {
      background: none;
      color: var(--color-text-primary);
    }

    &.button--fab {
      border-color: colors.$gray500;
      &:hover {
        color: colors.$gray500;
        background-color: colors.$white !important;
        border-color: colors.$gray500;
      }
    }
  }

  /**
  *   Disabled
  */
  &.button--disabled {
    opacity: 0.6;
  }

  /**
  *   Sizes
  */
  &.button--large {
    padding: spacing.$large-btn-padding;
    font-size: typography.$large-btn-font-size;
    line-height: typography.$large-btn-line-height;
  }

  &.button--xlarge {
    padding: spacing.$xlarge-btn-padding;
    font-size: typography.$xlarge-btn-font-size;
    line-height: typography.$xlarge-btn-line-height;
  }
  
  &.button--small {
    padding: spacing.$small-btn-padding;
    font-size: typography.$small-btn-font-size;
    line-height: typography.$small-btn-line-height;
  }

  &.button--xsmall {
    padding: spacing.$xsmall-btn-padding;
    font-size: typography.$xsmall-btn-font-size;
    line-height: typography.$xsmall-btn-line-height;
  }

  // Material Icons
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }

  .filled-icon.material-symbols-outlined{
    font-variation-settings: 'FILL' 1;
  }

  .button__icon {
    &--left {
      margin-right: 8px;
    }
    &--right {
      margin-left: 8px;
    }
  }

  /**
  *   Toggle Button
  */
  &.button--toggle {
    padding: spacing.$toggle-btn-padding;
    font-size: typography.$toggle-btn-font-size;
    border-radius: positioning.$toggle-btn-radius;
    min-width: spacing.$toggle-btn-min-width;
    min-height: spacing.$toggle-btn-min-height;
    line-height: typography.$toggle-btn-line-height;

    background-color: var(--color-bg-primary);
    color: var(--color-text-primary);
    border: positioning.$default-btn-border-width positioning.$default-btn-border-style var(--color-border-primary);
    &:not(.button--disabled):hover {
      background-color: var(--color-bg-primary-hover);
      border-color: var(--color-border-primary-hover);
    }
    
    &.button--toggle--toggled {
      background-color: var(--color-fill-primary);
      color: var(--color-text-invert);
      border-color: var(--color-border-brand);
      &:not(.button--disabled):hover {
        background-color: var(--color-fill-primary-hover);
        border-color: var(--color-border-brand-hover);
      }
    }
  }

  /**
  *   Visual Modifiers
  */
  &.button--bold {
    font-weight: bolder;
  }

  &.button--underlined {
    text-decoration: underline;
  }

  &.button--italic {
    font-style: italic;
  }

  &.button--rounded {
    border-radius: 50%;
  }

  /**
  *   Menu Button
  */
  &.button--menu {
    font-size: typography.$menu-btn-font-size;
    border-radius: 50%;
    padding: spacing.$default-menu-btn-padding;
    background-color: colors.$gray3;
    color: colors.$black;
    border: positioning.$default-btn-border-width positioning.$default-btn-border-style rgba(colors.$gray5, 0.5);
    transition: ease-out 0.3s;

    &.button--large {
      padding: spacing.$large-menu-btn-padding;
    }

    &.button--xlarge {
      padding: spacing.$xlarge-menu-btn-padding;
    }

    &.button--xsmall {
      padding: spacing.$xsmall-menu-btn-padding;
    }

    &.button--small {
      padding: spacing.$small-menu-btn-padding;
    }

    &:not(.button--disabled):hover {
      background-color: colors.$gray6;
      box-shadow: 0 4px 10px 0 rgba(colors.$black, 0.1);
    }

    &:not(.button--disabled):active {
      transition: none;
      background-color: colors.$gray7;
      border-color: colors.$gray400;
    }

    &.button--menu--toggle-ui {
      width: 40px;
      height: 48px;
      border-radius: 19px 0 0 19px;
      display: inline;
    }
  }

  /**
  *   FAB Button
  */
  &.button--fab {
    padding: spacing.$fab-btn-padding;
    font-size: typography.$fab-btn-font-size;
    border: positioning.$default-btn-border-width positioning.$default-btn-border-style colors.$blue4;
    
    &.button--large {
      padding: spacing.$fab-large-btn-padding;
    }
    &.button--xlarge {
      font-size: typography.$fab-xlarge-btn-font-size;
      padding: spacing.$fab-xlarge-btn-padding;
    }
    &.button--small {
      padding: spacing.$fab-small-btn-padding;
    }
    &.button--xsmall {
      font-size: typography.$fab-xsmall-btn-font-size;
      padding: spacing.$fab-xsmall-btn-padding;
    }
  }
}

/**
*   Block Button (replaces :host(.button--block))
*/
.button--block {
  display: block;
  width: 100%;
}

/**
*   FAB Button Container
*/
.fab-button {
  display: flex;
  width: fit-content;
  
  &.button--block {
    display: block;
    width: 100%;
  }
}
